import React, { useState } from 'react';
import { ListItemIcon, Menu, MenuItem } from '@material-ui/core';

interface MenuItem {
  text: string;
  icon?: React.ReactElement;
  action: string;
}

interface ContextMenuProps {
  menuItems: MenuItem[];
  onSelect: Function;
  enabled?: boolean;
  cursor?: string;
}

interface MouseCoordinates {
  mouseX: null | number;
  mouseY: null | number;
}

const ContextMenu = ({
  children,
  menuItems,
  onSelect,
  enabled = true,
  cursor = 'context-menu',
}: React.PropsWithChildren<ContextMenuProps>) => {
  const initialMouseCoordinates = {
    mouseX: null,
    mouseY: null,
  };

  const [mouseCoordinates, setMouseCoordinates] =
    useState<MouseCoordinates>(initialMouseCoordinates);

  if (!menuItems.length || !enabled) return <>{children}</>;

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setMouseCoordinates({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleClose = () => {
    setMouseCoordinates(initialMouseCoordinates);
  };

  const handleOnSelect = (option: any) => {
    onSelect(option);
    handleClose();
  };

  return (
    <div onContextMenu={handleClick} style={{ cursor }}>
      {children}
      <Menu
        open={mouseCoordinates.mouseY !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          mouseCoordinates.mouseY !== null && mouseCoordinates.mouseX !== null
            ? { top: mouseCoordinates.mouseY, left: mouseCoordinates.mouseX }
            : undefined
        }
      >
        {menuItems.map((option) => (
          <MenuItem key={option.text} onClick={() => handleOnSelect(option)}>
            {!!option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
            {option.text}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ContextMenu;
